//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getApiDataByContext from '~/utils/getApiDataByContext';
import tidalHeader from '@tidal/styles-header';
import { contentWrapper, errorComponent, headerComponent } from '@tidal/microservice-components';
import productDetails from '~/components/productDetails.vue';
import { tidalTab, tidalTabs } from '@tidal/styles-tabs';
import tidalFooter from '@tidal/styles-footer';
import languageSwitcher from '@tidal/language-switcher';
import { tidalTracking, tidalAmplitude, pushToDataLayer } from '@tidal/tracking';
import { getTranslationForSubscriptionType } from '../../../../api/utils/subscription.util';
import pathSelector from '~/utils/pathSelector';

export default {
    components: {
        contentWrapper,
        tidalHeader,
        headerComponent,
        // @ts-ignore
        tidalTab,
        tidalTabs,
        languageSwitcher,
        tidalFooter,
        errorComponent,
        productDetails,
    },
    asyncData: getApiDataByContext,
    data() {
        return {
            /** @type {{message: string} | null} */
            error: null,
            /** @type {import('../../../../api/models/clientSideUser.model').default | null} */
            user: null,
            currentModifier: '',
            langObject: null,
            /** @type {{title: string, subtitle: string, showSeeOtherOffersCopy: boolean} | null} */
            campaign: null,
            art: {
                show: false, cover: require('~/assets/images/campaign-art-placeholder.png'),
            },
            window: {
                width: 0,
                height: 0,
            },
            /** @type {import('@tidal/user-middleware').AppMode | null} */
            appMode: null,
            langPicked: '',
            /** @type {Array<string> | null} */
            availableLangs: null,
            flowInitiator: '',
            geo: '',
            campaignId: '',
            prepaidPrices: null,
            /** @type {OfferWeb.SubscriptionProducts | null} */
            subscriptionProducts: null,

            /** @type {import('@tidal/tracking').TidalTrackingInterface | null} */
            tidalTracking: null,
            trackingUuid: '',
            utms: null,
            awc: null,
            platform: null,
            deviceType: null,
            /** @type {import('@tidal/tracking').EventDataParams | OfferWeb.EventData | null} */
            eventData: null,
            isProd: false,
            enableThirdTier: false,
        };
    },
    computed: {
        /** @returns {Record<string, any>} */
        lang() {
            return pathSelector(this.langObject || {});
        },
        /** @returns {boolean} */
        showPlainTabTitle() {
            return this.subscriptionTypes.length === 1 && this.isClient;
        },
        /** @returns {Array<OfferWeb.StandardSubscriptionTypes> | []} */
        subscriptionTypes() {
            if (!this.subscriptionProducts) {
                return [];
            }
            return this.subscriptionProducts.standardSubscriptionTypes
                .filter(type => this.getProductsByType(type).length > 0);
        },
        /** @returns {boolean} */
        isClient() {
            return !!this.appMode;
        },
        /** @returns {Array<OfferWeb.SubscriptionProduct>} */
        premiumProducts() {
            return this.getProductsByType('PREMIUM');
        },
        /** @returns {Array<OfferWeb.SubscriptionProduct>} */
        premiumMidProducts() {
            return this.getProductsByType('PREMIUM_MID');
        },
        /** @returns {Array<OfferWeb.SubscriptionProduct>} */
        premiumPlusProducts() {
            return this.getProductsByType('HIFI').length > 0 ?
                this.getProductsByType('HIFI') : this.getProductsByType('PREMIUM_PLUS');
        },
        /** @returns {Array<Array<OfferWeb.SubscriptionProduct>>} */
        allProducts() {
            return [this.premiumProducts, this.premiumMidProducts, this.premiumPlusProducts];
        },
        /** @returns {OfferWeb.SubscriptionProduct | null} */
        firstEligibleProduct() {
            const products = this.allProducts.find(products => products.length);
            return products && products[0] || null;
        },
        /** @returns {string} */
        cssClassesForTidalTabs() {
            return `${this.showPlainTabTitle ? 'text-center margin-top-1' : ''} ${this.enableThirdTier && !this.isClient ?
                'product-selector--third-tier-tabs-color' : ''} ${this.enableThirdTier && this.isClient ?
                'product-selector--third-tier-tabs-color-client' : ''} ${this.enableThirdTier && !this.isClient ?
                'product-selector--third-tier-tabs-border-radius' : ''}`;
        },
    },
    created() {
        this.tidalTracking = tidalTracking({
            useProductionEndpoint: this.isProd,
        });
    },
    mounted() {
        this.eventData = {
            event: 'campaign-product-selector',
            email: '',
            geo: this.geo,
            campaignId: this.campaignId,
            flowInitiator: this.flowInitiator || '',
            appMode: this.appMode && this.appMode.type ? this.appMode.type : '',
            userId: this.user && this.user.id ? Number(this.user.id) : null,
            trackingUuid: this.trackingUuid,
            utms: this.utms || undefined,
            awc: this.awc || undefined,
            platform: this.platform || undefined,
            deviceType: this.deviceType || undefined,
        };
        // custom tag manger event only on prod
        if (window.location.hostname === 'offer.tidal.com' && this.flowInitiator && this.flowInitiator === 'TIDAL') {
            pushToDataLayer(Object.assign({}, this.eventData, {
                email: this.user && this.user.email ? this.user.email : '',
            }));
        }
        tidalAmplitude.sendEvent(this.user ? this.user.id : '', 'OFFERWEB_CAMPAIGN_PRODUCT_SELECTOR', this.eventData);
        // window width and height metrics
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        // default expand depending on the device witdh and number of offers
        if (this.firstEligibleProduct) {
            this.changeCurrentModifier(
                this.firstEligibleProduct.subscriptionType,
                this.firstEligibleProduct.subscriptionPlan,
            );
        }

        this.tidalTracking && this.tidalTracking.sendTidalPageViewEvent('web_display_page', this.eventData, {
            appMode: this.appMode,
            path: '/campaigns/products',
        }).catch(error => console.error(error));
    },
    beforeDestroy() {
        // window width and height metrics
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        /**
         * @param {OfferWeb.StandardSubscriptionTypes} type
         * @return {Array<OfferWeb.SubscriptionProduct>}
         */
        getProductsByType(type) {
            if (!this.subscriptionProducts) {
                return [];
            }

            return this.subscriptionProducts.items.filter(product => product.subscriptionType === type);
        },
        /**
         * @param {UserWebApi.SubscriptionType} type
         * @returns {string}
         */
        getTranslationType(type) {
            return getTranslationForSubscriptionType(type, this.enableThirdTier);
        },
        /**
         * @param {UserWebApi.SubscriptionType} type
         * @param {UserWebApi.SubscriptionPlan} plan
         */
        changeCurrentModifier(type, plan) {
            if (this.currentModifier === plan) {
                this.currentModifier = '';
            } else {
                this.currentModifier = plan;
            }
        },
        hideError() {
            this.error = null;
        },
        logout() {
            window.location.href = '/logout';
        },
        // window width and height metrics
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        /** @param {Record<string, any>} data */
        successHandler(data) {
            if (this.eventData) {
                this.tidalTracking && this.tidalTracking.sendTidalClickEvent('web_click', this.eventData, {
                    appMode: this.appMode,
                    buttonId: 'productselector_continue',
                    type: data.frontendProduct.subscriptionType,
                    plan: data.frontendProduct.subscriptionPlan,
                }).catch(error => console.error(error));
            }

            window.location.href = data.url;
        },
        /** @param {{error: {message: string}, isNetworkError?: boolean}} error */
        errorHandler(error) {
            // android signup flow don't show network error if any - the app will show the error message
            if (error.isNetworkError && this.appMode && this.appMode.type === 'ANDROID') {
                this.error = null;
            } else {
                this.error = error.error;
            }
        },
        /** @param {OfferWeb.SubscriptionProduct} product */
        isAriaExpanded(product) {
            return (this.currentModifier === product.subscriptionPlan) ? 'true' : 'false';
        },
    },
};
